(
    function (skyward, $)
    {
        skyward.accountlookupeel = skyward.accountlookupeel || {};
        skyward.accountlookupeel.typecodecombobox = {};

        var accountLookupEELList = [];
        var maximumNumberOfDimensions = null;

        var init = function (selector)
        {
            $(selector + ' .accountLookupEEL').each(function ()
            {
                skyward.accountlookupeel.initialize($(this));
            });
        };

        skyward.accountlookupeel.initialize = function (accountLookupEEL, accountSelector)
        {
            if (accountSelector)
            {
                accountLookupEEL = $(accountSelector);
            }
            if (!accountLookupEEL)
            {
                var eels = $(".accountLookupEEL").has(".accountLookupEELDisplayAccount[readonly!='readonly']");
                accountLookupEEL = eels.last();
            }
            var accountLookupEELDisplayAccount = accountLookupEEL.find('.accountLookupEELDisplayAccount');
            var accountLookupEELButton = accountLookupEEL.find(".accountLookupEELButton");
            var accountLookupEELValue = accountLookupEEL.find('.accountLookupEELValue');
            var accountLookupEELDimensionDescription = accountLookupEEL.find('.accountLookupEELDimensionDescription');
            var hiddenDisplayAccount = accountLookupEEL.find('.hiddenDisplayAccountValue');
            var linkingObjectField = accountLookupEEL.find('.linkingobjectfield');
            var fiscalyearid = accountLookupEEL.find('.fiscalyearid');
            var accountlookupadditionalfilterfield = accountLookupEEL.find('.accountlookupadditionalfilterfield');
            var codeEelName = accountLookupEELDisplayAccount.attr("id");
            var structureIsControlsType = accountLookupEELDisplayAccount.data("structureiscontrolstype");
            var fundLength = parseInt(accountLookupEELDisplayAccount.data("fundlength"));
            var isAccountReload = false;
            var reloadTypeCode = null;
            var popupContent = null;
            var popupContent_PopupId;
            var popupModalLayer = undefined;

            var showPopup = function ()
            {
                if (maximumNumberOfDimensions == null)
                {
                    findMaximumDimensions();
                }
                var offset = accountLookupEELDisplayAccount.offset();
                var height = accountLookupEELDisplayAccount.outerHeight();
                var popupDivName = codeEelName + "_popup";
                var detailsPanel = $("#detailsPanel");

                popupContent = $("<div class='popup skywardContentPanel' id='" + popupDivName + "' />");
                popupContent.css({ left: offset.left, top: offset.top + height, minWidth: 575 });

                //room for header label + 60 per select button and potential dimension eel
                popupContent.height(60 + (maximumNumberOfDimensions * 40));

                if (detailsPanel.length > 0)
                {
                    popupContent.width((skyward.window.clientWidth * .65) - detailsPanel.position().left);
                }
                else
                {
                    popupContent.width((skyward.window.clientWidth * .30) - offset.left);
                }

                if ((offset.top + height + popupContent.height()) > skyward.window.clientHeight)
                {
                    popupContent.css({ left: offset.left, top: offset.top - popupContent.height() });
                }

                var closeFunction = function ()
                {
                    popupContent = null;

                    accountLookupEELValue.val($('.SelectedAccount').val());
                    accountLookupEELValue.change();

                    updateBoxes();
                    accountLookupEELList.pop();
                    popupModalLayer = null;

                    skyward.accountLookupForm.destroy();
                };

                popupModalLayer = skyward.modalLayer.newModalLayer(popupContent, closeFunction,
                    {
                        expose: [accountLookupEELDisplayAccount],
                        afterClose: function ()
                        {
                            skyward.accountlookupeel.makeEditable();
                            accountLookupEELDisplayAccount.focus();
                        }
                    });

                popupContent_PopupId = skyward.window.loadContent(popupDivName, "Account", "Account", "AccountLookup", null, { "selectMode": true, "codeEelName": codeEelName }, undefined, undefined, undefined).skyward.popupId;
            };

            //need keypress to get numpad values correctly
            var keypress = function (event)
            {
                if (skyward.keys.keyIsNumberOrLetter(event.shiftKey, event.which))
                {
                    skyward.accountLookupForm.setInitialData(String.fromCharCode(event.which), fundLength + 1, structureIsControlsType);

                    if (!skyward.accountLookupForm.isInitialized && !popupModalLayer) //prevent multiple calls
                    {
                        var currentEELButton = $(event.target);

                        accountLookupEEL = currentEELButton.closest('.accountLookupEEL');
                        skyward.accountlookupeel.currentAccountLookupEELDisplayAccount = accountLookupEEL.find('.accountLookupEELDisplayAccount');

                        isAccountReload = false;
                        skyward.accountLookupForm.initialize(isAccountReload, reloadTypeCode, accountLookupEELDisplayAccount.val(), linkingObjectField, fiscalyearid, accountlookupadditionalfilterfield);
                        showPopup();
                    }
                }
            };

            var keydown = function (event)
            {
                if (event.which == 9) //Tab
                {
                    if (popupModalLayer)
                    {
                        popupModalLayer.close();
                    }
                }
                else if ((event.which == 13 || event.which == 8) && popupModalLayer == null)
                {
                    var currentEELButton = $(event.target);

                    accountLookupEEL = currentEELButton.closest('.accountLookupEEL');
                    skyward.accountlookupeel.currentAccountLookupEELDisplayAccount = accountLookupEEL.find('.accountLookupEELDisplayAccount');

                    isAccountReload = false;
                    skyward.accountLookupForm.initialize(isAccountReload, reloadTypeCode, accountLookupEELDisplayAccount.val(), linkingObjectField, fiscalyearid, accountlookupadditionalfilterfield);
                    showPopup();
                }
            };

            var keyup = function (event)
            {
                if (Array(27, 40, 38, 13).indexOf(event.which) == -1)
                {
                    var currentEELButton = $(event.target);

                    accountLookupEEL = currentEELButton.closest('.accountLookupEEL');
                    skyward.accountlookupeel.currentAccountLookupEELDisplayAccount = accountLookupEEL.find('.accountLookupEELDisplayAccount');

                    if (popupContent == null)
                    {
                        if (accountLookupEELDisplayAccount.val().length < 1)
                        {
                            isAccountReload = false;
                            skyward.accountLookupForm.initialize(isAccountReload, reloadTypeCode, accountLookupEELDisplayAccount.val(), linkingObjectField, fiscalyearid, accountlookupadditionalfilterfield);
                            showPopup();
                        }
                    }
                }
            };

            var updateBoxes = function (onLoad)
            {
                var accountLookupData = accountLookupEEL.data();
                $.ajax({
                    url: skyward.global.virtualDir + "Account/Account/AccountLookupEEL/" + accountLookupEELValue.val(),
                    type: "POST",
                    dataType: "JSON",
                    data:
                    {
                        DisplayAccount: accountLookupEELDisplayAccount.val(),
                        securityHash: accountLookupData.securityHash
                    },
                    success: function (data)
                    {
                        if (onLoad)
                        {
                            accountLookupEELDisplayAccount.attr("data-original-value", data.code);
                            accountLookupEELDimensionDescription.attr("data-original-value", data.description);
                        }
                        accountLookupEELDisplayAccount.val(data.code);
                        hiddenDisplayAccount.val(data.code);
                        accountLookupEELDimensionDescription.val(data.description);
                        reloadTypeCode = data.typeCode;
                        isAccountReload = data.isAccountReload;
                    }
                });
            };

            var findMaximumDimensions = function ()
            {
                $.ajax({
                    url: skyward.global.virtualDir + "Account/Account/FindMaximumNumberOfDimensions",
                    type: "POST",
                    dataType: "JSON",
                    async: false,
                    success: function (data)
                    {
                        maximumNumberOfDimensions = data.maximumDimensions;
                    }
                });
            };

            skyward.accountlookupeel.clearAccountTextbox = function ()
            {
                skyward.accountlookupeel.currentAccountLookupEELDisplayAccount.val(null);
            };

            skyward.accountlookupeel.makeReadOnly = function ()
            {
                skyward.accountlookupeel.currentAccountLookupEELDisplayAccount.attr('readonly', 'true');
            };

            skyward.accountlookupeel.makeEditable = function ()
            {
                skyward.accountlookupeel.currentAccountLookupEELDisplayAccount.removeAttr('readonly');
            };

            skyward.accountlookupeel.removeFieldset = function (event, deleteFieldID)
            {
                var target = $(event.target);

                if (deleteFieldID)
                {
                    var deleteField = $("#" + deleteFieldID);
                    if (deleteField.val() != "null")
                    {
                        deleteField.val(deleteField.val() + "," + target.parents(".accountDistribution").eq(0).attr("data-accountingid"));
                    }
                    else
                    {
                        deleteField.val(target.parents(".accountDistribution").eq(0).attr("data-accountingid"));
                    }
                }

                target.parents('[id*="_AccountDistribution"]').remove();
                target.closest("fieldset").remove();

                $('[id*="iconSave"]').addClass("dirty");
                $('[id*="_save"]').attr('disabled', false).addClass("dirty");
                $('[id*="_cancel"]').attr('disabled', false).addClass("dirty");
            };

            //event hooks
            accountLookupEELDisplayAccount.keydown(keydown);
            accountLookupEELDisplayAccount.keyup(keyup);
            accountLookupEELDisplayAccount.keypress(keypress);
            accountLookupEELDisplayAccount.on("click", function (event)
            {
                if (accountLookupEELDisplayAccount.val().length < 1)
                {
                    skyward.accountlookupeel.currentAccountLookupEELDisplayAccount = $(event.target);

                    if (popupContent == null)
                    {
                        isAccountReload = false;
                        skyward.accountLookupForm.initialize(isAccountReload, reloadTypeCode, accountLookupEELDisplayAccount.val(), linkingObjectField, fiscalyearid, accountlookupadditionalfilterfield);
                        showPopup();
                    }
                }
            });
            accountLookupEELButton.on("click", function (event)
            {
                var currentEELButton = $(event.target);
                accountLookupEEL = currentEELButton.closest('.accountLookupEEL');
                skyward.accountlookupeel.currentAccountLookupEELDisplayAccount = accountLookupEEL.find('.accountLookupEELDisplayAccount');

                isAccountReload = false;
                skyward.accountLookupForm.initialize(isAccountReload, reloadTypeCode, accountLookupEELDisplayAccount.val(), linkingObjectField, fiscalyearid, accountlookupadditionalfilterfield);
                showPopup();
            });
        };

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);
